<script setup lang="ts">
import { LoaderOverlay } from '@shared/ui/loaders'

import { useDisciplinePageLoader } from '../model/discipline-page-loader.hook'

defineOptions({
  name: 'DisciplinePageLoader',
})

const props = withDefaults(defineProps<{
  /** The page's own first read, shown under the same loader as the discipline. */
  loading?: boolean
}>(), {
  loading: false,
})

const { refIsShown } = useDisciplinePageLoader({
  loading: computed(() => props.loading),
})
</script>

<template>
  <LoaderOverlay v-if="refIsShown" />
</template>
